import React, { useState } from "react";
import { Mail, ArrowLeft } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import { forgotPassword } from "../ApiHelper/url_Helpers";
import { RiseLoader } from "react-spinners";
import { toasterSuccess, toasterError } from "./toaster";
import "./loader.css";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await forgotPassword({ email });
      toasterSuccess("OTP sent to your email");
      // Store email in sessionStorage to use in next steps
      sessionStorage.setItem("resetEmail", email);
      navigate("/verify-otp");
    } catch (err) {
      setError(err?.message || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex flex-col md:flex-row items-center justify-center bg-white p-4 md:gap-x-14">
      <div className="w-full md:w-1/2 flex justify-center md:justify-end items-center mb-10 md:mb-0 md:pr-4">
        <div className="relative max-w-[500px]">
          <img
            src="/cuate.png" 
            alt="Forgot Password Illustration"
            className="w-full h-auto"
          />
        </div>
      </div>

      <div className="w-full md:w-1/2 flex justify-center md:justify-start md:pl-4">
        <div className="w-full max-w-[450px] bg-[#f0f9ff] rounded-[32px] p-5 md:p-8 border border-gray-300">
          <div className="mb-5">
            <Link 
              to="/login" 
              className="flex items-center text-sm font-semibold text-[#1a2333] hover:underline mb-4"
            >
              <ArrowLeft size={16} className="mr-1" /> Back to Login
            </Link>
            <h1 className="text-3xl font-bold text-[#1a1a1a] mb-2">
              Forgot Password?
            </h1>
            <p className="text-gray-500 text-lg">
              Enter your email address to receive an OTP
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            {error && (
              <p className="text-red-500 text-sm mb-4 bg-red-50 p-2 rounded-lg text-center">
                {error}
              </p>
            )}

            <div className="relative group mb-6">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <Mail className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500" />
              </div>

              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
                className="block w-full pl-12 pr-4 py-3 bg-white border rounded-xl text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all border-gray-300"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-[#1a2333] hover:bg-[#252f44] text-white font-semibold py-3 rounded-xl transition-all shadow-md ${loading ? "opacity-70" : "active:scale-[0.99]"}`}
            >
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </form>

          {loading && (
            <div className="loader-col">
              <RiseLoader color="#35e6e9" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
